import { initReactI18next } from "react-i18next"
import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import english from "./en/translation.json"
import spanish from "./es/translation.json"

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    // Guard against invalid detected languages (e.g. the `lng` longitude query
    // param that the search bar puts in the URL) leaking into i18n.language.
    supportedLngs: ["en", "es"],
    nonExplicitSupportedLngs: true,
    debug: import.meta.env.DEV,
    resources: { en: { translation: english }, es: { translation: spanish } },
    detection: {
      // The default querystring key is `lng`, which collides with the longitude
      // `lng` param used across the app's map URLs. Use a dedicated key instead.
      lookupQuerystring: "lang",
    },
  })

/** Active app language (BCP-47 tag, e.g. "en", "es", "pt-BR"), independent of browser locale. */
export function getAppLanguage(): string {
  return i18next.resolvedLanguage || i18next.language || "en"
}

/** Google Maps `language` param — ISO 639-1, matching the app UI (not the browser). */
export function getGoogleMapsLanguage(): string {
  return getAppLanguage().toLowerCase().startsWith("es") ? "es" : "en"
}

/**
 * Switch app language and reload the page.
 * A full reload keeps locale-dependent UI consistent (Maps, dates, third-party widgets)
 * without hunting down every component that reads locale only on mount.
 */
export async function changeAppLanguage(language: string): Promise<void> {
  if (getAppLanguage() === language) return

  await i18next.changeLanguage(language)
  window.location.reload()
}
